import { getOwnerDocument as f } from "../dom/index.js";
import { isActiveElement as u, isInputElement as p } from "../tabbable/index.js";
const a = (t) => {
  const o = f(t), l = o.defaultView ?? window;
  let e = t.parentNode;
  const c = [], r = o.scrollingElement || o.documentElement;
  for (; e instanceof l.HTMLElement && e !== r; )
    (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) && c.push({
      element: e,
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft
    }), e = e.parentNode;
  return r instanceof l.HTMLElement && c.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), c;
};
let s = null;
const d = () => {
  if (s == null) {
    s = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return s = !0, !0;
        }
      });
    } catch {
    }
  }
  return s;
}, m = (t) => {
  t.forEach(({ element: o, scrollTop: l, scrollLeft: e }) => {
    o.scrollTop = l, o.scrollLeft = e;
  });
}, g = (t, o = {}) => {
  const {
    isActive: l = u,
    nextTick: e,
    preventScroll: c = !0,
    selectTextIfInput: r = !0
  } = o;
  if (!t || l(t)) return -1;
  const n = () => {
    if (t) {
      if (d())
        t.focus({ preventScroll: c });
      else if (t.focus(), c) {
        const i = a(t);
        m(i);
      }
      p(t) && r && t.select();
    }
  };
  return e ? requestAnimationFrame(n) : (n(), -1);
};
export {
  g as focus
};
//# sourceMappingURL=index.js.map
